import { useLang } from 'hooks/lang';

import { loaders } from 'entities';

import { LabeledSelect } from 'components/Blocks';
import { getUserLabel } from 'components/Inputs';

import { useUser } from 'hooks';

import { sortByName } from 'utils/array';

import { StateProps } from './types';

export function Sales({ dispatch, state }: StateProps) {
  const user = useUser();
  const { t } = useLang();

  const { data: sales, loading: loadingSales } = loaders.users.salesUsers.use({
    defaultValue: [],

    blockLoad: !open,

    parser: sortByName,
  });

  return (
    <LabeledSelect
      id="sales"
      label={t('sales') as string}
      isMulti
      onChangeDirect={(sales) => dispatch({ sales })}
      value={state.sales}
      labelKey="name"
      options={sales.filter(({ id }) => id !== user.id && !state.executors.includes(id))}
      loading={loadingSales}
      formatLabel={getUserLabel}
    />
  );
}
